import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateEmailMutation = createMutationHook(OrderApiClient.updateEmail, {
  mutationKey: ['updateEmail'],
})
